export default {
  badge: {
    color: "#366b92",
    backgroundColor: "#ebf0f4",
    fontWeight: 600,
  },
};
